import BlogPostLayout from "./BlogPostLayout";

export default BlogPostLayout;